<template>
  <div class="app-wrapper">
    <!-- <sidebar class="sidebar-container" /> -->
    <div :class="{ hasTagsView: needTagsView }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <div class="flex page-top flex_between flex_items">
          <div class="flex flex_items">
            <!-- <img src="@/assets/index/logo.png" alt="logo" class="logo"> -->
            <div class="pl20">安得儿童乐园窗口售票系统</div>
            <div class="flex f16" style="padding-left: 50px;">
              <!-- <div v-for="(item, index) in nav" :key="index" class="nav-item flex flex_items flex_center"
                :class="[checkThis == item.id ? 'page_main_bg cf' : '', item.isShow || item.show ? '' : 'none']"
                @click="pageTo(item)">
                <ICON :checkThis="checkThis" :id="item.id"></ICON>
                {{ item.showName }}
              </div> -->
              <el-button type="primary" v-if="role.includes('v1.window.order.makeup')" @click="goto">补打</el-button>
            </div>
          </div>
          <div>{{ windowName }}</div>
          <!-- 头像 -->
          <div class="flex flex_items">
            <el-link type="primary" style="margin-top: 5px;margin-right: 10px;"><a href="https://help.anage.cn/web/#/72" target="_blank">帮助文档</a></el-link>
            <div class="right-menu flex flex_items">
              <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
                <div class="avatar-wrapper flex flex_items f15 c6">
                  <!-- <img :src="require('@/assets/index/user-h.png')" class="user-avatar"> -->
                  <span class="user-name flex_shrink"><span class="mr10"></span> {{ user ? user.nickname :
                    '' }}</span>
                  <i class="el-icon-arrow-down"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <!-- <router-link to="/profile/index">
                  <el-dropdown-item>aa</el-dropdown-item>
                </router-link> -->
                  <!-- <router-link to="/">
                  <el-dropdown-item>Dashboard</el-dropdown-item>
                </router-link>
                <a target="_blank" href="https://github.com/PanJiaChen/vue-element-admin/">
                  <el-dropdown-item>Github</el-dropdown-item>
                </a>
                <a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">
                  <el-dropdown-item>Docs</el-dropdown-item>
                </a>
                -->
                  <el-dropdown-item @click.native="changepw">
                    <span style="display:block;">修改密码</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="logout">
                    <span style="display:block;">退出登录</span>
                  </el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

        </div>
        <!-- 导航 -->
        <!-- <div class="pc_container">
          <navbar />
        </div> -->
      </div>
      <!-- 主题内容 -->
      <app-main />
    </div>


    <el-dialog title="修改密码" :visible.sync="dis" width="500px" append-to-body :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="原密码" prop="old_password">
          <el-input v-model="ruleForm.old_password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="ruleForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password_confirmation">
          <el-input v-model="ruleForm.password_confirmation" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="dis = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

// import RightPanel from '@/components/RightPanel'
import { AppMain, Navbar, Sidebar } from './components'
// import ResizeMixin from './mixin/ResizeHandler'
// import { mapState } from 'vuex'
import { navlist } from '@/utils/settings'
import ICON from './components/icon.vue'
import { loginNextPageShow } from '@/utils/tool'
import { getUserMsg, removeToken } from "@/utils/auth"



export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar, ICON,
    Sidebar,
  },
  data() {
    var validateUsername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请确认密码'));
      }
      if (value != this.ruleForm.password) {
        return callback(new Error('两次密码不一致'));
      }
      callback();
    };
    return {
      needTagsView: true,
      fixedHeader: true,
      nav: navlist,
      checkThis: -1,
      user: '',
      role: [],
      windowName: '',
      dis: false,
      ruleForm: {
        old_password: '',
        password: '',
        password_confirmation: '',
      },
      rules: {
        old_password: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
        ],
        password_confirmation: [
          { validator: validateUsername, trigger: 'blur' },
          { required: true, message: '请确认密码', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    $route(to, from) {
      // console.log(to,from);
      if (to) {
        this.checkThis = to.meta.belong
      }
      // this.fetchUserData(to.params.id);
    },
    // "$store.getters.user": {
    //   handler: function (params) {
    //     console.log(params,'65786');

    //     if (params) {
    //       // this.user = JSON.parse(params);
    //     }
    //   },
    //   deep: true
    // },
  },
  created() {
    // this.user = this.$store.getters.userMsg;
    this.user = getUserMsg() ? JSON.parse(getUserMsg()) : null;
    this.checkThis = this.$route.meta.belong;
    // console.log(getUserMsg(),'a-00--');
    this.nav = loginNextPageShow()
    this.role = this.$store.getters.roles
    // console.log(this.role);
    this.api.getUrl('/api/v1/window/window/info').then(res => {
      this.windowName = res.name
    })
    // console.log(this.nav);
    // console.log(this.checkThis);

  },
  methods: {
    submitForm(formName) {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.api.postUrl('/api/v1/window/user/password', this.ruleForm, { loading: true }).then(res => {
            this.$message.success('修改成功')
            this.dis = false
          })
        } else {
          return false;
        }
      }, (r) => {
        console.log(r);

      });
    },
    changepw() {
      this.ruleForm = {
        old_password: '',
        password: '',
        password_confirmation: '',
      }
      this.dis = true;
      this.$refs['ruleForm'].resetFields();
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    pageTo(item) {
      this.$router.push(item.path)
      this.checkThis = item.id;
    },
    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('role')
      this.$store.dispatch('app/setIslogin', 0);
      removeToken()
      this.$router.push('/login?code=' + localStorage.getItem('code'))
    },
    goto() {
      this.$router.push('/makeup')
    },

  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";

// @import "~@/styles/variables.scss";
.none {
  display: none
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.page-top {
  border-bottom: 1px solid #E6E8EB;
  height: 68px;
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  // width: calc(100% - #{$sideBarWidth});
  width: 100%;
  transition: width 0.28s;
  margin-bottom: 12px;
  background: #fff;
  // height: 50px;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px)
}

.mobile .fixed-header {
  width: 100%;
}

.logo {
  width: 118px;
  height: 38px;
  display: block;
  margin-right: 120px;
}

.nav-item {
  cursor: pointer;
  width: 100px;
  height: 64px;
  text-align: center;
  line-height: 64px;
}

.right-menu {
  // float: right;
  height: 100%;
  // line-height: 50px;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    // height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background .3s;

      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }
  }

  .avatar-container {
    margin-right: 30px;

    .avatar-wrapper {
      margin-top: 5px;
      position: relative;

      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: block;
        object-fit: cover;
      }

      .user-name {
        margin: 0 12px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>
